var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.263 0H8.73697L6.85874 5.82489L0.780594 5.8249L0 8.24571L4.91733 11.8457L3.03911 17.6705L5.08274 19.1667L10 15.5667L14.9173 19.1667L16.9609 17.6705L15.0827 11.8457L20 8.24569L19.2193 5.82489H13.1413L11.263 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/Quality.eaa22167a3ed87be9adf8d5694270967.svg";
export { ForwardRef as ReactComponent };